import React, { useEffect, useState } from 'react'
import { useAlert } from 'react-alert'
import { useHistory, useLocation } from 'react-router-dom'
import { constructContentModel } from '../../../domain/models/admin-models'
import CreateConstruct from '../../../presentation/components/new-construct/create-construto'
import {
  saveConstruct,
  updateConstruct
} from '../../usecases/admin-menu/construct'
const CreateConstructFactory = () => {
  const alert = useAlert()
  const history = useHistory()
  const location: any = useLocation()
  const [constructData, setconstructData] = useState<constructContentModel>()
  useEffect(() => {
    setconstructData(location.state)
  }, [location])
  const data = [
    {
      hasTestInput: 'true',
      component: 'Input',
      label: 'Código construto',
      labelColor: 'black',
      wrapperClassName: 'create-construct-inputs',
      value: constructData?.cdConstruto,
      disabled: true,
      onChange: (e: any) => {
        setconstructData((prev) => ({ ...prev, cdConstruto: e.target.value }))
      }
    },
    {
      component: 'Input',
      label: 'Construto',
      labelColor: 'black',
      wrapperClassName: 'create-construct-inputs',
      value: constructData?.construto,
      onChange: (e: any) => {
        setconstructData((prev) => ({ ...prev, construto: e.target.value }))
      }
    },
    {
      component: 'SelectInput',
      options: [
        { label: 'LAYOUT_PADRÃO', value: 'LAYOUT_PADRAO' },
        { label: 'LAYOUT_COMPLEMENTAR', value: 'LAYOUT_COMPLEMENTAR' },
        { label: 'LAYOUT_PERSONALIDADE', value: 'LAYOUT_PERSONALIDADE' }
      ],
      label: 'Categoria',
      labelColor: 'black',
      wrapperClassName: 'create-construct-inputs',
      value: constructData?.categoriaConstruto,
      onChange: (e: any) => {
        setconstructData((prev) => ({
          ...prev,
          categoriaConstruto: e.target.value
        }))
      }
    }
  ]
  const handleClick = async () => {
    try {
      constructData?.cdConstruto
        ? await updateConstruct().update(constructData)
        : await saveConstruct().post(constructData)
      alert.show('construto salvo com sucesso!', {
        type: 'success',
        timeout: 4000
      })
      history.push(`/cadastro-de-construto`)
    } catch (error) {
      alert.show('Erro ao salvar um construto', {
        type: 'error',
        timeout: 4000
      })
    }
  }
  return <CreateConstruct data={data} handleClick={handleClick} />
}
export default CreateConstructFactory
